import { OAuthModuleConfig } from 'angular-oauth2-oidc';

export const createOAuthConfig: () => OAuthModuleConfig = (): OAuthModuleConfig => {
  return {
    resourceServer: {
      sendAccessToken: true,
      customUrlValidation: addAccessToken
    }
  };
};

/**
 * Checks if access token is needed for request.
 * @param url the URL
 * @returns true if access token should be added
 */
export function addAccessToken(url: string): boolean {
  return !url.endsWith('/configuration/properties');
}

export default createOAuthConfig;
